import { create } from 'zustand';

/**
 * UI Store - Manages UI state (modals, sidebar, breadcrumbs, etc.)
 * 
 * Usage:
 *   const sidebarOpen = useUIStore(s => s.sidebarOpen);
 *   const toggleSidebar = useUIStore(s => s.toggleSidebar);
 */
export const useUIStore = create((set) => ({
  // ==========================================
  // SIDEBAR
  // ==========================================
  sidebarOpen: true,
  
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  
  // ==========================================
  // ACTIVE SECTION (cameras, organizations, users, etc.)
  // ==========================================
  activeSection: 'cameras',
  
  setActiveSection: (section) => set({ activeSection: section }),
  
  // ==========================================
  // MODALS
  // ==========================================
  cameraModalOpen: false,
  cameraModalMode: 'add', // 'add' or 'edit'
  cameraModalData: null,
  
  openCameraModal: (mode = 'add', data = null) => set({
    cameraModalOpen: true,
    cameraModalMode: mode,
    cameraModalData: data,
  }),
  
  closeCameraModal: () => set({
    cameraModalOpen: false,
    cameraModalMode: 'add',
    cameraModalData: null,
  }),
  
  // Organization modal
  orgModalOpen: false,
  orgModalMode: 'add',
  orgModalData: null,
  
  openOrgModal: (mode = 'add', data = null) => set({
    orgModalOpen: true,
    orgModalMode: mode,
    orgModalData: data,
  }),
  
  closeOrgModal: () => set({
    orgModalOpen: false,
    orgModalMode: 'add',
    orgModalData: null,
  }),
  
  // Site modal
  siteModalOpen: false,
  siteModalMode: 'add',
  siteModalData: null,
  
  openSiteModal: (mode = 'add', data = null) => set({
    siteModalOpen: true,
    siteModalMode: mode,
    siteModalData: data,
  }),
  
  closeSiteModal: () => set({
    siteModalOpen: false,
    siteModalMode: 'add',
    siteModalData: null,
  }),
  
  // User modal
  userModalOpen: false,
  userModalMode: 'add',
  userModalData: null,
  
  openUserModal: (mode = 'add', data = null) => set({
    userModalOpen: true,
    userModalMode: mode,
    userModalData: data,
  }),
  
  closeUserModal: () => set({
    userModalOpen: false,
    userModalMode: 'add',
    userModalData: null,
  }),
  
  // ==========================================
  // CONFIRM DIALOG
  // ==========================================
  confirmDialogOpen: false,
  confirmDialogConfig: null,
  
  openConfirmDialog: (config) => set({
    confirmDialogOpen: true,
    confirmDialogConfig: config,
  }),
  
  closeConfirmDialog: () => set({
    confirmDialogOpen: false,
    confirmDialogConfig: null,
  }),
  
  // ==========================================
  // BREADCRUMBS
  // ==========================================
  breadcrumbs: [],
  
  setBreadcrumbs: (crumbs) => set({ breadcrumbs: crumbs }),
  
  addBreadcrumb: (crumb) => set((state) => ({
    breadcrumbs: [...state.breadcrumbs, crumb],
  })),
  
  clearBreadcrumbs: () => set({ breadcrumbs: [] }),
}));
